<div *ngFor="let tab of tabs" class="tab" [class.active]="tab.active" (click)="selectTab(tab)" role="presentation">
    <h5 [ngClass]="{ disabled: tab.disabled }">
        {{ tab.title }}
    </h5>
    <app-badge *ngIf="tab.badgeCount as badgeCount">
        {{ badgeCount }}
    </app-badge>
</div>
